import type { RefObject } from 'react';
import type { RenderBlock } from './CalendarRow';
import { CalendarRow } from './CalendarRow';
import type { BlockDragListeners, CalendarDay } from './types';

interface CalendarGridProps extends BlockDragListeners {
    graphGridRef: RefObject<HTMLDivElement>;
    days: CalendarDay[];
    timeColumns: string[];
    loading?: boolean;
    buildMode?: boolean;
    onMouseLeave?: () => void;
    allBlocksPerDay: Map<CalendarDay, RenderBlock[]>;
}

export function CalendarGrid({
    graphGridRef,
    days,
    timeColumns,
    loading,
    buildMode,
    blockDragStart,
    blockDragMove,
    blockDragEnd,
    onMouseLeave,
    allBlocksPerDay,
}: CalendarGridProps): JSX.Element {
    return (
        <div
            ref={graphGridRef}
            className="mt-1"
            onMouseLeave={() => {
                if (buildMode) {
                    onMouseLeave?.();
                }
            }}
        >
            <div className="relative flex">
                {Array.from({ length: 24 }).map((_, index) => (
                    <div key={index} className="border-light-gray h-2 grow border-x-[0.5px] px-3" />
                ))}
            </div>
            {days.map((day) => (
                <CalendarRow
                    key={day.key}
                    day={day}
                    timeColumns={timeColumns}
                    loading={loading}
                    buildMode={buildMode}
                    blockDragStart={blockDragStart}
                    blockDragMove={blockDragMove}
                    blockDragEnd={blockDragEnd}
                    allBlocksPerDay={allBlocksPerDay}
                />
            ))}
        </div>
    );
}
